(() => {
  const bootScript = document.currentScript;
  const loadedApps = new Set();

  const loadExternalScript = (name, src) => {
    if (!src || loadedApps.has(name)) return;
    loadedApps.add(name);

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.casekooLoadedApp = name;
    document.head.appendChild(script);
  };

  const loadJoy = () => loadExternalScript('joy', bootScript?.dataset.casekooJoySrc || '');

  const joySelector = [
    'a[href*="#joy-home"]',
    'a[href*="joy-home"]',
    '[data-casekoo-open-joy]',
  ].join(',');

  document.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest(joySelector)) loadJoy();
    },
    { capture: true, passive: true }
  );

  if (window.location.hash.toLowerCase().includes('joy')) loadJoy();
  window.addEventListener('hashchange', () => {
    if (window.location.hash.toLowerCase().includes('joy')) loadJoy();
  });

  // Tidio is intentionally disabled to keep storefront rendering responsive.
})();
